<template>
  <div>
    <div class="bjffff"></div>
    <div class="btBox">
      <div class="cont">
        <div class="logoimg img">
          <img src="../../assets/img/logo.png" alt="" srcset="" />
          <div class="shu"></div>
          <div class="name">修改密码</div>
        </div>
      </div>
    </div>
    <div class="dlBox">
      <div class="content">
        <div class="title">修改密码</div>
        <div class="cont">
          <div class="inp">
            <a-input placeholder="填写当前密码" v-model="old_password" />
          </div>
          <div class="inp">
            <a-input placeholder="请输入密码" v-model="new_password" />
          </div>
          <div class="inp">
            <a-input placeholder="请输入确定密码" v-model="confirm_password" />
          </div>
        </div>
        <div class="serveBox" @click="saveClick">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Form, Input, Button, Upload, Icon } from "ant-design-vue";
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-input-password": Input.Password,
    "a-button": Button,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
  },
  name: "",
  data() {
    return {
      typeOn: 0,
      typeList: ["普通登录", "短信快捷登录"],
      zhShow: false,
      time: 60,
      yzmShow: false,
      old_password: "",
      mobile: "",
      new_password: "",
      confirm_password: "",
    };
  },
  created() { },
  methods: {
    typeClick(i) {
      this.typeOn = i;
    },
    zhShowJs() {
      this.zhShow = !this.zhShow;
    },
    saveClick() {
      let data = {
        old_password: this.old_password,
        new_password: this.new_password,
        confirm_password: this.confirm_password,
      }
      if (!this.old_password) {
        this.$message.error("请输入验证码");
        return;
      }
      if (!this.new_password) {
        this.$message.error("请输入密码");
        return;
      }
      if (!this.confirm_password) {
        this.$message.error("请输入确认密码");
        return;
      }
      if (this.new_password != this.confirm_password) {
        this.$message.error("密码和确认密码不一致");
        return;
      }
      this.$post("/nozzle/web/update_oldpassword", data).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.$message.success("密码修改成功,请重新登录");
          this.$router.replace({
            path: "/login",
            query: {},
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    mimaClick() {
      this.$router.push({
        path: "/mima",
        query: {},
      });
    },
  },
  mounted() { },
  computed: {},
};
</script>
<style lang="less" scoped>
.btBox {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  background-color: #fff;
  box-shadow: 0 2px 2px 1px whitesmoke;
  font-family: PingFangSC-Regular, sans-serif;

  .cont {
    width: 1440px;
    margin: auto;
    display: flex;
    height: 55px;
    align-items: center;
    justify-content: space-between;

    .logoimg {
      height: 30px;
      display: flex;
      align-items: center;

      img {
        height: 100%;
        width: auto;
      }

      .shu {
        width: 1px;
        height: 15px;
        margin: 0 10px;
        background-color: #999;
      }

      .name {
        font-size: 18px;
        font-weight: 700;
        color: #333;
      }
    }
  }
}

.dlBox {
  width: 420px;
  border: 1px solid #e0e0e0;
  margin: auto;
  margin-top: 200px;
  border-radius: 5px;
  overflow: hidden;

  .headBox {
    height: 50px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;

    .box {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background-color: #ebebeb;
      cursor: pointer;
      color: #9c9c9c;
    }

    .on {
      color: #000;
      background-color: #fff;
    }
  }

  .content {
    padding: 25px;

    .title {
      font-weight: 600;
      font-size: 18px;
      text-align: center;
    }

    .cont {
      margin-top: 10px;

      .inp {
        margin-top: 20px;
        height: 40px;
        position: relative;

        .yzmBox {
          position: absolute;
          top: 1px;
          right: 1px;
          width: 80px;
          height: calc(100% - 2px);
          background-color: #332b2b;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 12px;
        }

        .ant-input {
          height: 100% !important;
        }

        .ant-input-affix-wrapper {
          height: 100%;
        }

        /deep/input {
          height: 100%;
        }
      }
    }

    .funBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 15px;

      .jzBox {
        display: flex;
        align-items: center;
        cursor: pointer;

        .kuang {
          width: 14px;
          height: 14px;
          border-radius: 2px;
          border: 1px solid #999;
          margin-right: 10px;
          display: flex;
          align-items: center;
          justify-content: center;

          .iconfont {
            font-size: 12px;
            color: #e20808;
            font-weight: 600;
          }
        }

        .name {
          color: #9c9c9c;
          font-size: 12px;
        }
      }

      .wjBox {
        cursor: pointer;

        .name {
          font-size: 12px;
          color: #9c9c9c;
        }
      }
    }

    .serveBox {
      width: 100%;
      height: 40px;
      background-color: #e20808;
      color: #fff;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-top: 20px;
    }
  }
}
</style>
